import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="py-8 border-t border-gray-700 text-center">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <p className="text-sm text-gray-400 mb-4">
            Copyright © 2024 Trading Pro Academy
          </p>
          <p className="text-xs text-gray-500 mb-6">
            T.P.A. SRL P.Iva 15403761008 Iscritta presso la camera di commercio di Roma n. REA RM – 1588349 Capitale Sociale € 10.000 Interamente versato
          </p>
          <div className="text-xs text-gray-500 space-y-3 max-w-3xl mx-auto">
            <p>
              Trading Pro Academy ed ogni suo collaboratore non possono e non forniscono alcuna garanzia in merito alla tua capacità di ottenere risultati o guadagnare denaro con le nostre idee, informazioni, strumenti o strategie.
            </p>
            <p>
              Nulla in questa pagina, nei nostri siti Web o nei nostri contenuti o percorsi formativi è una promessa o garanzia di risultati o guadagni futuri e non offriamo alcuna consulenza legale, medica, fiscale o professionale. Tutti i numeri economico-finanziari a cui si fa riferimento qui o su uno dei nostri siti sono solo indicativi di concetti e non devono essere considerati guadagni medi, guadagni esatti o promesse per prestazioni effettive o future. Presta attenzione e consulta sempre il tuo commercialista, avvocato o consulente professionale prima di agire su questa o qualsiasi informazione relativa a un cambiamento di stile di vita o alla tua attività o alle tue finanze. Solo tu sei responsabile delle tue decisioni, azioni e risultati nella vita, e con la tua registrazione qui accetti di non tentare di ritenerci responsabili delle tue decisioni, azioni o risultati, in qualsiasi momento, in qualsiasi circostanza.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};